var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",attrs:{"id":"app"}},[(_vm.loading)?_c('the-app-loader'):_c('router-view'),_c('noscript',[_vm._v("Please enable JavaScript to use this app")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }